/**
 * useDebounce Hook
 * 
 * Verzögert die Aktualisierung eines Wertes um eine bestimmte Zeit.
 * Nützlich für Suchen/Autocomplete um API-Calls zu reduzieren.
 */
import { useState, useEffect } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    
    return () => clearTimeout(timer);
  }, [value, delay]);
  
  return debouncedValue;
}

export default useDebounce;



